import { useQuery } from "@tanstack/react-query";
import type { VisaBulletinData } from "@shared/schema";
import { buildVisaBulletinAsOfLine } from "@shared/aeo-copy";
import { buildWhichChartLine } from "@/lib/visa-bulletin-data";

interface BulletinResponse {
  current: VisaBulletinData;
}

export function VisaBulletinAsOfLine({ className }: { className?: string }) {
  const { data } = useQuery<BulletinResponse>({ queryKey: ["/api/visa-bulletin"] });
  if (!data?.current) return null;
  return (
    <>
      <p className={className} data-testid="text-visa-bulletin-as-of">
        {buildVisaBulletinAsOfLine(data.current)}
      </p>
      <p className={className} data-testid="text-dates-for-filing-choice">
        {buildWhichChartLine(data.current)}
      </p>
    </>
  );
}

interface AeoAnswerProps {
  question: string;
  answer: string;
  asOfLines?: readonly string[];
  visaBulletinAsOf?: boolean;
  headingClassName?: string;
  textClassName?: string;
  asOfClassName?: string;
}

export function AeoAnswer({
  question,
  answer,
  asOfLines,
  visaBulletinAsOf,
  headingClassName,
  textClassName,
  asOfClassName,
}: AeoAnswerProps) {
  return (
    <section className="mb-10" data-testid="section-aeo-answer">
      <h2 className={headingClassName}>{question}</h2>
      <p className={textClassName} data-testid="text-aeo-answer">
        {answer}
      </p>
      {asOfLines?.map((line) => (
        <p key={line} className={asOfClassName} data-testid="text-aeo-as-of">
          {line}
        </p>
      ))}
      {visaBulletinAsOf && <VisaBulletinAsOfLine className={asOfClassName} />}
    </section>
  );
}
